import { drawBokehEffect } from '@tensorflow-models/body-pix';

// Apply a blur effect to the background of the canvas based on person segmentation
export const blurEffect = (canvas, previewElem, personSegmentation, backgroundBlurAmount) => {
    // Define edge blur amount and whether to flip the image horizontally
    const edgeBlurAmount = 3;
    const flipHorizontal = false;

    // Draw the image with the background blurred onto the canvas.
    drawBokehEffect(canvas, previewElem, personSegmentation, backgroundBlurAmount, edgeBlurAmount, flipHorizontal);
};

// Render the background image onto the canvas, considering person segmentation
export const renderBackgroundImg = (personSegmentation, backgroundImg, backgroundImageData, backgroundCtx, ctx, personImageData) => {
    // Define canvas dimensions
    const canvasWidth = 640;
    const canvasHeight = 480;

    // Extract segmentation data and temporary image data
    const segmentationData = personSegmentation.data;
    const tempData = personImageData.data;

    // If background image data is not available, extract it from the background image
    if (backgroundImageData === null) {
        backgroundCtx.drawImage(backgroundImg, 0, 0, canvasWidth, canvasHeight);
        backgroundImageData = backgroundCtx.getImageData(0, 0, canvasWidth, canvasHeight);
    }

    // Extract background image data
    const backgroundData = backgroundImageData.data;

    // Create a new blank image
    const newImageData = ctx.createImageData(canvasWidth, canvasHeight);
    const data = newImageData.data;

    // Copy the user or the background to the new image
    for (let i = 0; i < data.length; i += 4) {
        if (segmentationData[i / 4] !== 0) {
            // Copy pixel data from the temporary image for the person
            data[i] = tempData[i];
            data[i + 1] = tempData[i + 1];
            data[i + 2] = tempData[i + 2];
            data[i + 3] = 255;
        } else {
            // Copy pixel data from the background image for non-person areas
            data[i] = backgroundData[i];
            data[i + 1] = backgroundData[i + 1];
            data[i + 2] = backgroundData[i + 2];
            data[i + 3] = backgroundData[i + 3];
        }
    }
    // Render the new image onto the canvas
    ctx.putImageData(newImageData, 0, 0);
};
